import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function UniqueMechanism() {
  const plants = [{
    emoji: '🌿',
    name: 'Lavanda',
    compoundLabel: 'Compuestos activos',
    compound: 'Linalool + acetato de linalilo',
    benefits: ['Ayuda a reducir la presión arterial', 'Desacelera el pulso', 'Activa el sistema nervioso parasimpático (modo descanso)']
  }, {
    emoji: '🌼',
    name: 'Manzanilla',
    compoundLabel: 'Compuesto activo',
    compound: 'Apigenina',
    benefits: ['Se une a los receptores GABA del cerebro', 'Reduce la actividad mental acelerada', 'Ayuda a relajar el sistema nervioso sin dependencia']
  }, {
    emoji: '🌺',
    name: 'Pasiflora',
    compoundLabel: 'Compuestos activos',
    compound: 'Crisina + flavonoides',
    benefits: ['Ayuda a detener pensamientos repetitivos', 'Reduce la actividad neuronal asociada al estrés', 'Permite que la mente baje de revoluciones']
  }];
  return <section className="px-6 py-5 max-w-4xl mx-auto" data-id="element-481">
      <FadeIn data-id="element-482">
        <div className="text-lg md:text-xl leading-relaxed text-[#2D2A26] max-w-3xl mx-auto mb-8" data-id="element-483">
          <p className="text-2xl md:text-3xl font-serif font-bold text-[#9B4F2B] text-center" data-id="element-484">
            Las 3 plantas que ayudan a tu sistema nervioso a salir del modo
            alerta
          </p>
          <br data-id="element-485" />
          <p className="text-[16px]" data-id="element-486">No hablamos de creencias vagas.</p>
          <br data-id="element-487" />
          <p className="text-[16px]" data-id="element-488">
            Hablamos de compuestos naturales que interactúan directamente con tu
            sistema nervioso.
          </p>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/nF7JkWjsNkWix8Soj3CbVR/imagen_4_para_la_pagina_de_venta.png" alt="Plantas medicinales — lavanda, manzanilla y pasiflora" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg mb-10" data-id="element-489" />

        <div className="flex flex-col gap-6 mb-8 max-w-xl mx-auto" data-id="element-490">
          {plants.map((plant, index) => <div key={index} className="bg-[#F3EDE4] rounded-3xl p-7 md:p-9 relative overflow-hidden" data-id="element-491">
              {/* Decorative organic blob */}
              <svg className="absolute top-0 left-0 w-32 h-32 opacity-40" viewBox="0 0 200 200" fill="none" data-id="element-492">
                <path d="M40,-10 C80,10 120,-20 160,30 C200,80 170,140 120,160 C70,180 20,140 -10,90 C-40,40 0,-30 40,-10Z" fill="#D6CCBA" data-id="element-493" />
              </svg>
              <div className="relative z-10" data-id="element-494">
                <h3 className="font-serif text-3xl md:text-4xl font-bold text-[#3B4A2F] mb-2" data-id="element-495">
                  {plant.emoji} {plant.name}
                </h3>
                <p className="text-sm font-bold text-[#9B4F2B] mb-4 uppercase tracking-wider" data-id="element-496">
                  {plant.compoundLabel}: {plant.compound}
                </p>
                <p className="text-sm font-semibold text-[#2D2A26] mb-2" data-id="element-497">
                  Qué hace:
                </p>
                <ul className="space-y-2" data-id="element-498">
                  {plant.benefits.map((benefit, i) => <li key={i} className="flex items-start gap-2 text-[#2D2A26]/80 leading-relaxed text-base" data-id="element-499">
                      <span className="text-[#4A5D3A] mt-0.5 flex-shrink-0" data-id="element-500">
                        ✔
                      </span>
                      <span data-id="element-501">{benefit}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>

        {/* Science block */}
        <div className="max-w-xl mx-auto mb-10 mt-2 bg-white/70 border border-[#C4A265]/20 rounded-2xl px-6 py-7 md:px-8 md:py-9 shadow-sm" data-id="element-502">
          <p className="font-serif font-bold text-xl md:text-2xl text-[#3B4A2F] text-center mb-4" data-id="element-503">
            ¿Por qué estas plantas realmente funcionan?
          </p>
          <p className="text-[15px] text-[#2D2A26]/80 leading-relaxed mb-4" data-id="element-504">
            Diversos estudios han demostrado que ciertos compuestos naturales
            presentes en plantas como:
          </p>
          <ul className="space-y-2 mb-5 pl-1" data-id="element-505">
            <li className="flex items-center gap-2 text-[15px] text-[#2D2A26]/90" data-id="element-506">
              <span className="w-2 h-2 rounded-full bg-[#C4A265] flex-shrink-0" data-id="element-507"></span>
              <span data-id="element-508">
                <strong className="text-[#9B4F2B]" data-id="element-509">Apigenina</strong>{' '}
                (manzanilla)
              </span>
            </li>
            <li className="flex items-center gap-2 text-[15px] text-[#2D2A26]/90" data-id="element-510">
              <span className="w-2 h-2 rounded-full bg-[#C4A265] flex-shrink-0" data-id="element-511"></span>
              <span data-id="element-512">
                <strong className="text-[#9B4F2B]" data-id="element-513">Linalool</strong> (lavanda)
              </span>
            </li>
            <li className="flex items-center gap-2 text-[15px] text-[#2D2A26]/90" data-id="element-514">
              <span className="w-2 h-2 rounded-full bg-[#C4A265] flex-shrink-0" data-id="element-515"></span>
              <span data-id="element-516">
                <strong className="text-[#9B4F2B]" data-id="element-517">Flavonoides</strong>{' '}
                (pasiflora)
              </span>
            </li>
          </ul>
          <p className="text-[15px] text-[#2D2A26]/80 leading-relaxed mb-3" data-id="element-518">
            …interactúan con el sistema nervioso ayudando a activar el{' '}
            <strong className="text-[#3B4A2F]" data-id="element-519">modo de descanso natural</strong>{' '}
            del cuerpo.
          </p>
          <p className="text-[15px] text-[#2D2A26]/80 leading-relaxed" data-id="element-520">
            Por eso, cuando se preparan correctamente, pueden ayudar a reducir
            la actividad mental acelerada y permitir que tu mente finalmente{' '}
            <strong className="text-[#3B4A2F]" data-id="element-521">baje de revoluciones</strong>.
          </p>
        </div>

        <p className="text-sm font-bold text-[#9B4F2B] text-lg md:text-xl text-center mb-5 mt-2" data-id="element-522">
          Pero hay un detalle que casi nadie menciona cuando habla de plantas
          calmantes…
        </p>
        <br data-id="element-523" />
        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-lg border border-[#C4A265]/30 max-w-3xl mx-auto relative" data-id="element-524">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-[#C4A265] text-center text-white px-6 py-2 rounded-full font-bold tracking-wide text-sm" data-id="element-525">
            El Secreto que cambia todo
          </div>

          <p className="text-lg md:text-xl text-center mb-5 mt-2" data-id="element-526">
            La mayoría de las personas cree que el problema es la planta.
          </p>
          <p className="text-lg md:text-xl text-center mb-5 mt-2" data-id="element-527">
            Pero casi nunca lo es.
          </p>

          <p className="text-2xl md:text-3xl font-serif font-bold text-center text-[#9B4F2B] mb-6" data-id="element-528">
            El Verdadero Problema es la dosis.
          </p>

          <div className="space-y-3 text-center text-[#2D2A26]/80" data-id="element-529">
            <p data-id="element-530">
              Un sobre de té de supermercado contiene aproximadamente 0.5 gramos
              de planta seca.
            </p>
            <p data-id="element-531">
              Eso es demasiado poco para producir un efecto real en el sistema
              nervioso.
            </p>
            <p data-id="element-532">
              Para generar una señal biológica de calma, la mayoría de las
              plantas necesita entre 3 y 6 veces esa cantidad.
            </p>
          </div>

          <div className="mt-8 text-center space-y-2" data-id="element-533">
            <p className="font-bold text-xl" data-id="element-534">No es la planta que falla.</p>
            <p className="font-bold text-xl text-[#4A5D3A]" data-id="element-535">
              Es la dosis. Es el método. Es la combinación.
            </p>
          </div>
        </div>

        <div className="text-center mt-12" data-id="element-536">
          <p className="text-xl mb-4" data-id="element-537">
            Y eso es exactamente — y solo eso — lo que cambia con el:
          </p>

          {/* How the method was built block */}
          <div className="bg-[#F3EDE4] rounded-2xl px-6 py-7 md:px-9 md:py-10 max-w-2xl mx-auto mb-10 text-left border border-[#D6CCBA]/40" data-id="element-538">
            <p className="font-serif font-bold text-xl md:text-2xl text-[#3B4A2F] text-center mb-5" data-id="element-539">
              Cómo se construyó el Método de Rescate Botánico
            </p>
            <div className="space-y-4 text-[15px] md:text-base text-[#2D2A26]/85 leading-relaxed" data-id="element-540">
              <p data-id="element-541">
                El Método de Rescate Botánico no nació de una moda de bienestar
                ni de recetas de internet.
              </p>
              <p data-id="element-542">
                Se basa en la observación de cómo ciertos compuestos naturales
                presentes en plantas medicinales interactúan con el sistema
                nervioso humano.
              </p>
              <p data-id="element-543">
                Durante siglos, plantas como la manzanilla, la lavanda y la
                pasiflora han sido utilizadas para ayudar al cuerpo a pasar del
                estado de alerta al estado de descanso.
              </p>
              <p className="font-semibold text-[#2D2A26]" data-id="element-544">
                Lo que cambia con este método no es la planta.
              </p>
              <p data-id="element-545">
                Es la <strong className="text-[#9B4F2B]" data-id="element-546">dosis correcta</strong>
                , la{' '}
                <strong className="text-[#9B4F2B]" data-id="element-547">combinación adecuada</strong>{' '}
                y la{' '}
                <strong className="text-[#9B4F2B]" data-id="element-548">
                  forma precisa de preparación
                </strong>{' '}
                para enviar al sistema nervioso la señal que necesita para salir
                del modo alerta.
              </p>
            </div>
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#4A5D3A] tracking-tight mb-8" data-id="element-549">
            MÉTODO DE RESCATE BOTÁNICO
          </h2>

          <a href="https://pay.hotmart.com/Y104754180A?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block w-full max-w-lg mx-auto text-center bg-[#4A5D3A] text-[#FAF6F0] font-bold py-5 px-8 rounded-xl shadow-lg hover:bg-[#3a4a2e] transition-colors text-base md:text-lg" data-id="element-550">
            QUIERO EL PROTOCOLO COMPLETO → Acceso instantáneo por $6.39 USD
          </a>
        </div>
      </FadeIn>
    </section>;
}